import React from 'react';
export function BackgroundGrid() {
  return <div className="fixed inset-0 z-[-1] overflow-hidden pointer-events-none bg-brand-bg" data-id="element-12">
      {/* Grid Pattern */}
      <div className="absolute inset-0 opacity-[0.15]" style={{
      backgroundImage: `
            linear-gradient(to right, rgba(255,255,255,0.1) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255,255,255,0.1) 1px, transparent 1px)
          `,
      backgroundSize: '40px 40px',
      maskImage: 'radial-gradient(ellipse at center, black 40%, transparent 80%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center, black 40%, transparent 80%)'
    }} data-id="element-13" />

      {/* Ambient Glows */}
      <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-brand-blue opacity-20 blur-[120px] animate-pulse-slow" data-id="element-14" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[50%] rounded-full bg-brand-green opacity-10 blur-[120px] animate-pulse-slow" style={{
      animationDelay: '2s'
    }} data-id="element-15" />
    </div>;
}